export default __webpack_public_path__ + "static/media/Astro_Taurus_Black.502a6661.png";